import { wsService } from "./wsService";

const section = "inventory";

function filter_lpn(param = { enable: true }) {
  return wsService.make_post_request(section + "/lpn/list", param);
}

function filter_ubicacion(param = { enable: true }) {
  return wsService.make_post_request(section + "/ubicacion/list", param);
}

function filter_por_atributos(param = { enable: true }) {
  return wsService.make_post_request(section + "/atributos/list", param);
}

function get_stock(param = { enable: true }) {
  return wsService.make_post_request(section + "/stock/get", param);
}

function get_shipment_orders_by_lpn(param = {}) {
  return wsService.make_post_request(section + "/lpn/shipment-orders", param);
}

export const inventoryService = {
  section,
  filter_lpn,
  filter_ubicacion,
  filter_por_atributos,
  get_stock,
  get_shipment_orders_by_lpn
};
